import HotelParkingInformation from './HotelParkingInformation';
export default HotelParkingInformation;